import { render, staticRenderFns } from "./CalculateResult.vue?vue&type=template&id=50f712f6&scoped=true&"
import script from "./CalculateResult.vue?vue&type=script&lang=js&"
export * from "./CalculateResult.vue?vue&type=script&lang=js&"
import style0 from "./CalculateResult.vue?vue&type=style&index=0&id=50f712f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f712f6",
  null
  
)

export default component.exports